module.exports = __webpack_public_path__ + "static/media/ss-blue-and-cream-parser.cfab2584.png";